<template>
  <article class="navbar">
    <section class="navbar__icon">
      <img src="https://ippassets.s3.us-east-2.amazonaws.com/logo.png" alt="">
    </section>
    <section class="navbar__links" v-if="!isMobile()">
      <div
        class="navbar__links--section"
        @click="scrollToElement('slider')">
        <p>Inicio</p>
      </div>
      <div
        class="navbar__links--section"
        @click="scrollToElement('us')">
        <p>Quienes Somos</p>
      </div>
      <div
        class="navbar__links--section"
        @click="scrollToElement('products_and_services')">
        <p>Servicios y Productos</p>
      </div>
      <div
        class="navbar__links--section"
        @click="scrollToElement('experience')">
        <p>Experiencia</p>
      </div>
      <div
        class="navbar__links--section"
        @click="scrollToElement('clients')">
        <p>Clientes</p>
      </div>
      <div
        class="navbar__links--section"
        @click="scrollToElement('human_talent')">
        <p>Talento Humano</p>
      </div>
      <!-- <div class="navbar__links--section with_img" @click="redirectToBackoffice()">
        <img src="https://ippassets.s3-us-west-2.amazonaws.com/user.svg" alt="">
        <p>Acceso</p>
      </div>
      <div
        class="navbar__links--section with_img"
        @click="updateContactModal(true)">
        <img src="https://ippassets.s3-us-west-2.amazonaws.com/mail.svg" alt="">
        <p>Contáctenos</p>
      </div> -->
    </section>
    <section class="navbar__links" v-else>
      <div class="navbar__links--section with_img" @click="show_drawer = !show_drawer">
        <app-menu-icon></app-menu-icon>
      </div>
    </section>
    <section class="navbar__mobile_nav" v-if="isMobile() && show_drawer">
      <div
        class="navbar__links--section"
        @click="show_drawer = false; scrollToElement('slider')">
        <p>Inicio</p>
      </div>
      <div
        class="navbar__links--section"
        @click="show_drawer = false; scrollToElement('us')">
        <p>Quienes Somos</p>
      </div>
      <div
        class="navbar__links--section"
        @click="show_drawer = false; scrollToElement('products_and_services')">
        <p>Servicios y Productos</p>
      </div>
      <div
        class="navbar__links--section"
        @click="show_drawer = false; scrollToElement('experience')">
        <p>Experiencia</p>
      </div>
      <div
        class="navbar__links--section"
        @click="show_drawer = false; scrollToElement('clients')">
        <p>Clientes</p>
      </div>
      <div
        class="navbar__links--section"
        @click="show_drawer = false; scrollToElement('human_talent')">
        <p>Talento Humano</p>
      </div>
      <div
        class="navbar__links--section with_img"
        @click="show_drawer = false; redirectToBackoffice()">
        <p>Acceso</p>
      </div>
      <div
        class="navbar__links--section with_img"
        @click="show_drawer = false; updateContactModal(true)">
        <p>Contáctenos</p>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  data(){
    return{
      show_drawer: false
    }
  },
  methods:{
    redirectToBackoffice(){
      window.open('http://www.ipp.com.s3-website-us-west-2.amazonaws.com', '_blank');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/Navbar.vue